import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RegisterModal from './SignUpDialogs/RegisterModal';
import CloseIcon from '@mui/icons-material/Close';
import { Radio } from '@mui/material';
import SignUp from './SignUpDialogs/SignUp';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 814,
    borderRadius: 5,
    bgcolor: 'background.paper',
    p: 4,
};

function Welcomecoachmodal({ open, setOpen, role }) {
    const [addRegisterModalAction, setAddRegisterModalAction] = useState(false);
    const [checked, setChecked] = useState("Yes");
    const handleOpen = () => setOpen(true);
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpen(false);
    }
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <p className="modalmain">
                        <span style={{ marginLeft: 'auto' }}>
                            Welcome to PPLACD
                        </span>
                        <CloseIcon sx={{ marginLeft: 'auto', cursor: 'pointer' }} onClick={handleClose} />
                    </p>
                    <hr></hr>
                    <p className="modkick">
                        Kick Start your journey by creating Your Account.
                    </p>
                    <p className="caradv">We want to help you to give career advice to the top-notch candidates. Provide your Services / Career advice and help them on finding a job, exploring different career paths, and succeeding in their career.</p>
                    <span className="agreemod">Do you agree that your profile will go for a third party background verification <a className="nodec" href="url">Yes or No ?</a> </span>
                    <FormGroup className="coachmod">
                        <FormControlLabel value="Yes" control={<Radio
                            checked={checked === 'Yes'}
                            onChange={() => setChecked("Yes")}
                            value="Yes"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'A' }}
                        />} label="Yes" />
                        <FormControlLabel value="No" control={
                            <Radio
                                checked={checked === 'No'}
                                onChange={() => setChecked("No")}
                                value="No"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'No' }}
                            />
                        } label="No" />
                    </FormGroup>
                    <hr></hr>
                    <p className="quesmod">If you have any further question regarding joining please email to <a className="nodec" href="mailto:someone@example.com">info@pplacd.com</a></p>
                    <p className="modcenter"><Button variant="contained" sx={{width:'80%',height:'3rem'}} disabled={checked === "No"} onClick={() => { setOpen(false); setAddRegisterModalAction(true) }}>Proceed</Button></p>
                </Box>
            </Modal>
            <SignUp
            role={role}
            addSignUpAction={addRegisterModalAction}
            setAddSignUpAction={setAddRegisterModalAction}
          />
        </div>
    );
}

export default Welcomecoachmodal;
